import { FC, useState, ChangeEvent } from 'react';
import {
  StyledDialog,
  SubtitleSecondary,
  ReasonTextArea,
  ButtonContainer,
  RejectButton,
  CancelButton,
} from 'src/components/DialogBox/RejectDialog/RejectDialog.styles';
import ConfirmHeader from 'src/components/Headers/ConfirmationHeader';
import { CloseIcon } from 'src/components/DialogBox/DialogBox.styles';

interface RejectDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
  title?: string;
  subtitle?: string;
  subtitleSecondary?: string;
  placeholder?: string;
  confirmText?: string;
}

const RejectDialog: FC<RejectDialogProps> = ({
  open,
  onClose,
  onConfirm,
  title = 'Reject',
  subtitle = 'Are you sure you want to reject this item?',
  subtitleSecondary = 'Once rejected, this action cannot be reversed.',
  placeholder = '',
  confirmText = 'Reject',
}) => {
  const [reason, setReason] = useState('');
  const [touched, setTouched] = useState(false);

  const handleReasonChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    setReason(e.target.value);
    setTouched(true);
  };
  const isReasonEmpty = reason.trim().length === 0;

  const handleConfirm = () => {
    if (reason.trim()) {
      onConfirm(reason);
    } else {
      setTouched(true);
    }
  };

  const handleClose = () => {
    setReason('');
    setTouched(false);
    onClose();
  };

  return (
    <StyledDialog open={open} onClose={handleClose}>
      <ConfirmHeader
        iconColor="var(--error)"
        title={title}
        subtitle={subtitle}
      />
      <CloseIcon
        component="i"
        className="bx bx-x-circle"
        onClick={handleClose}
      />
      {subtitleSecondary && (
        <SubtitleSecondary>{subtitleSecondary}</SubtitleSecondary>
      )}
      <ReasonTextArea
        placeholder={placeholder}
        value={reason}
        onChange={handleReasonChange}
        style={{
          borderColor: touched && isReasonEmpty ? 'var(--error)' : undefined,
        }}
      />
      <ButtonContainer>
        <RejectButton onClick={handleConfirm} disabled={isReasonEmpty}>
          {confirmText}
        </RejectButton>
        <CancelButton onClick={handleClose}>Cancel</CancelButton>
      </ButtonContainer>
    </StyledDialog>
  );
};

export default RejectDialog;
